export type APILibraryCategoryResponseType = Partial<{
  id: number;
  url: string;
  name: string;
  is_system: boolean;
  created: string;
  modified: string;
}>;
export type APILibraryCategoryRequestType = Pick<
  Required<APILibraryCategoryResponseType>,
  "name"
>;
export interface IAPILibraryCategory {
  toRequestModel(): APILibraryCategoryRequestType;
  isDataValid(): boolean;
  getData(): APILibraryCategoryResponseType;
}

export class APILibraryCategory implements IAPILibraryCategory {
  readonly data: APILibraryCategoryResponseType;
  constructor(data: APILibraryCategoryResponseType) {
    this.data = data;
  }
  getData(): APILibraryCategoryResponseType {
    return this.data;
  }
  isDataValid(): boolean {
    return !!this.data.name;
  }
  toRequestModel(): APILibraryCategoryRequestType {
    if (this.isDataValid()) {
      return {
        name: this.data.name!.trim(),
      };
    }
    throw new Error("Invalid data: name is required");
  }
}
